import React from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import styles from './Landing.module.scss'
import MultiCarousel from './MultiCarousel'
import { PuzzlePieceIcon } from '@heroicons/react/24/solid'
import { ShareIcon } from '@heroicons/react/24/solid'
import { ClockIcon } from '@heroicons/react/24/solid'
import { ArrowsPointingOutIcon } from '@heroicons/react/24/solid'
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/24/solid'
import { useRef, useState, useEffect } from 'react'
import SkewCarousel from './SkewCarousel'
import { MainHeader } from '../../../layout/Header/MainHeader'
import { MainFooter } from '../../../layout/MainFooter'
import { useNavigate } from 'react-router-dom'
import { useAuthStatus } from '../../../utils'
import { useUser } from '../../../hooks/user'
import { useIsMobile } from '../../../hooks'
import MobileMultiCarousel from './MobileMultiCarousel'

const Landing = () => {
	const darkContainerTitleRef = useRef(null)
	const darkContainerRef = useRef(null)
	const [isDarkContainerTitleIsVisible, setIsDarkContainerTitleIsVisible] = useState(false)
	const navigate = useNavigate()
	const [auth] = useAuthStatus()
	const { data: user } = useUser()
	const isMobile = useIsMobile()

	useEffect(() => {
		// 초기 상태 체크: 이미 뷰포트에 있는지 확인
		const checkInitialVisibility = () => {
			if (darkContainerRef.current) {
				const rect = darkContainerRef.current.getBoundingClientRect()
				const isVisible = rect.top < window.innerHeight && rect.bottom > 0
				if (isVisible) {
					setIsDarkContainerTitleIsVisible(true)
					return true
				}
			}
			return false
		}

		// 초기 체크 실행
		const isInitiallyVisible = checkInitialVisibility()

		// 이미 보이는 경우 observer는 필요 없음
		if (isInitiallyVisible) {
			return
		}

		// IntersectionObserver 설정
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setIsDarkContainerTitleIsVisible(true) // ✨ 뷰포트에 들어오면 is-visible을 true로 설정
						observer.unobserve(entry.target) // 한 번만 실행되도록 관찰 중단
					}
				})
			},
			{
				threshold: 0.1, // 요소의 10%가 보일 때 트리거 (모바일에서도 더 잘 작동)
				rootMargin: '50px', // 뷰포트 경계에서 50px 전에 미리 트리거
			},
		)

		if (darkContainerRef.current) {
			observer.observe(darkContainerRef.current) // ✨ div를 관찰 대상에 추가
		}

		return () => {
			// 컴포넌트 언마운트 시 정리
			if (darkContainerRef.current) {
				observer.unobserve(darkContainerRef.current)
			}
		}
	}, []) // 한 번만 실행

	return (
		<>
			<MainHeader />
			<div className={styles.announcementBanner}>
				<div className={styles.bannerContent}>
					<div className={styles.bannerIcon}>🎯</div>
					<div className={styles.bannerText}>
						<span className={styles.bannerTitle}>
							2026년을 위한 사전계약 기능 오픈!
						</span>
						<span className={styles.bannerSubtitle}>
							지금 미리 계약하고 내년 시즌을 준비하세요
						</span>
					</div>
					<button
						className={styles.bannerButton}
						onClick={() => {
							if (auth.isAuthentication) {
								navigate('/search')
							} else {
								navigate('/login', { state: { from: '/search' } })
							}
						}}>
						바로가기
					</button>
				</div>
			</div>
			<div className={styles.mainFrame}>
				<div className={styles.upScreenFirstContainer}>
					<div className={styles.mainWordBox}>
						<div className={styles.bigWord}>
							실력 있는 선수와, 능력 있는 캐디가 <br />
							서로에게 제안하는 곳
						</div>
						<div className={styles.bigWordMobile}>
							실력 있는 선수와, 능력 있는 <br />
							캐디가 서로에게 제안하는 곳
						</div>
						<div className={styles.smallWord}>
							경기의 완성은 믿을 수 있는 동행에서 시작됩니다. 스포이음에서 대회 일정과
							조건에 맞는 선수·캐디를 찾고, 제안-계약-정산까지 한 번에 처리하세요.
						</div>
						<div className={styles.smallWordMobile}>
							경기의 완성은 믿을 수 있는 동행에서 시작됩니다. <br />
							스포이음에서 대회 일정과 조건에 맞는 선수·캐디를 찾고,
							<br />
							제안-계약-정산까지 한 번에 처리하세요.
						</div>
					</div>
				</div>
				{!isMobile ? <MultiCarousel key="desktop" /> : <MobileMultiCarousel key="mobile" />}
				{/* <div className={styles.announcementContainer}>
					<div className={styles.announcmentHeader}>
						<div className={styles.title}>
							<img src={'/images/moneyImage.png'} className={styles.moneyImage}></img>
							단기간 고수익을 보장하는 프리미엄 공고
						</div>
						<div className={styles.next}>
							<div className={styles.nextToggle}>
								<ChevronLeftIcon className={styles.chevron} />
								<span className={styles.highLight}>1</span>
								<span className={styles.normal}>/3</span>
								<ChevronRightIcon className={styles.chevron} />
							</div>
						</div>
						<div className={styles.announcementBox}>
							<div className={styles.mainAnnouncement}>
								{
									'[장기계약] 오래 함께하실분 / 백송홀딩스-아시아드CC 부산오픈 / 8월말 / 3박4일...'
								}
							</div>
							<div className={styles.announcementOption}>
								<div>장기계약</div>
								<div>주급</div>
								<div>123,200,000원 / 12,700,000원</div>
							</div>
							<div className={styles.timeCreated}>16시간 전</div>
						</div>
						<div className={styles.announcementBox}>
							<div className={styles.mainAnnouncement}>
								{
									'오래 함께할 분 / 백송홀딩스-아시아드CC 부산오픈 / 8월말 / 3박4일 일정'
								}
							</div>
							<div className={styles.announcementOption}>
								<div>기간계약</div>
								<div>일시불제</div>
								<div>123,123,123원</div>
							</div>
							<div className={styles.timeCreated}>1일 전</div>
						</div>
						<div className={styles.announcementBox}>
							<div className={styles.mainAnnouncement}>
								{
									'[장기계약] 오래 함께하실분 / 백송홀딩스-아시아드CC 부산오픈 / 8월말 / 3박4일...'
								}
							</div>
							<div className={styles.announcementOption}>
								<div>장기계약</div>
								<div>주급</div>
								<div>123,200,000원 / 12,700,000원</div>
							</div>
							<div className={styles.timeCreated}>16시간 전</div>
						</div>
						<div className={styles.announcementBox}>
							<div className={styles.mainAnnouncement}>
								{
									'오래 함께할 분 / 백송홀딩스-아시아드CC 부산오픈 / 8월말 / 3박4일 일정'
								}
							</div>
							<div className={styles.announcementOption}>
								<div>기간계약</div>
								<div>일시불제</div>
								<div>123,123,123원</div>
							</div>
							<div className={styles.timeCreated}>1일 전</div>
						</div>
					</div>
				</div> */}
				{!isMobile ? (
					<div className={styles.darkContainer} ref={darkContainerRef}>
						<div
							className={`${styles.darkContainerTitle} ${isDarkContainerTitleIsVisible ? styles['isVisible'] : ''}`}
							ref={darkContainerTitleRef}>
							이제, 필드 위 최적의 파트너를 계약과 정산까지 한 번에
						</div>
						<div
							className={`${styles.darkMainContent} ${isDarkContainerTitleIsVisible ? styles['isVisible'] : ''}`}>
							<div className={styles.darkMainContentTop}>
								<div className={styles.borderRightGradient}>
									<PuzzlePieceIcon className={styles.darkContentIcon} />
									<span className={styles.whiteBoldText}>딱 맞는 대회 매칭</span>
									<span className={styles.whiteText}>
										원하는 대회 일정과 필요 경력에 맞춰, 최적의
										파트너(선수/캐디)를 직접 검색하고 매칭합니다.
									</span>
								</div>
								<div className={styles.borderRightGradient}>
									<ShareIcon className={styles.darkContentIcon} />
									<span className={styles.whiteBoldText}>번거로움 없는 계약</span>
									<span className={styles.whiteText}>
										복잡한 절차 없이 '공고-제안-계약'으로 이어지는 투명하고
										스마트한 프로세스를 경험하세요.
									</span>
								</div>
								<div>
									<ClockIcon className={styles.darkContentIcon} />
									<span className={styles.whiteBoldText}>
										시간 절약 & 효율 극대화
									</span>
									<span className={styles.whiteText}>
										현장의 비효율을 없애고, 한 번의 계약으로 일정 관리와 정산,
										알림까지 스포이음이 대신 처리합니다.
									</span>
								</div>
							</div>
							<div className={styles.darkMainContentBottom}>
								<div className={styles.borderRightGradient}>
									<ArrowsPointingOutIcon className={styles.darkContentIcon} />
									<span className={styles.whiteBoldText}>
										검증된 파트너 POOL, 더 넓은 선택의 기회
									</span>
									<span className={styles.whiteText}>
										선수는 다양한 경력과 스타일의 캐디를 비교·선택할 수 있고,
										캐디는 여러 선수와의 장·단기 계약 기회를 확보할 수 있습니다.
									</span>
								</div>
								<div>
									<ChatBubbleOvalLeftEllipsisIcon
										className={styles.darkContentIcon}
									/>
									<span className={styles.whiteBoldText}>
										신뢰할 수 있는 안전 정산 시스템
									</span>
									<span className={styles.whiteText}>
										스포이음이 계약부터 정산까지, 투명하고 안전한 파트너십을
										보장합니다.
									</span>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className={styles.mobileDarkContainer} ref={darkContainerRef}>
						<div
							className={`${styles.mobileDarkContainerTitle} ${isDarkContainerTitleIsVisible ? styles['isVisible'] : ''}`}
							ref={darkContainerTitleRef}>
							이제, 필드 위 최적의 파트너를 <br />
							계약과 정산까지 한 번에
						</div>
						<div
							className={`${styles.mobileDarkMainContent} ${isDarkContainerTitleIsVisible ? styles['isVisible'] : ''}`}>
							{/* <div className={styles.darkMainContentTop}> */}
							{/* <div className={styles.borderRightGradient}> */}
							<div className={styles.mobileDarkMainContentItem}>
								<PuzzlePieceIcon className={styles.darkContentIcon} />
								<span className={styles.mobileWhiteBoldText}>
									딱 맞는 대회 매칭
								</span>
								<span className={styles.mobileWhiteText}>
									원하는 대회 일정과 필요 경력에 맞춰, 최적의 <br />
									파트너(선수/캐디)를 직접 검색하고 매칭합니다.
								</span>
							</div>
							{/* <div className={styles.borderRightGradient}> */}
							<div className={styles.mobileDarkMainContentItem}>
								<ShareIcon className={styles.darkContentIcon} />
								<span className={styles.mobileWhiteBoldText}>
									번거로움 없는 계약
								</span>
								<span className={styles.mobileWhiteText}>
									복잡한 절차 없이 '공고-제안-계약'으로 이어지는 투명하고 스마트한
									프로세스를 경험하세요.
								</span>
							</div>
							<div className={styles.mobileDarkMainContentItem}>
								<ClockIcon className={styles.darkContentIcon} />
								<span className={styles.mobileWhiteBoldText}>
									시간 절약 & 효율 극대화
								</span>
								<span className={styles.mobileWhiteText}>
									현장의 비효율을 없애고, 한 번의 계약으로 일정 관리와 정산,
									알림까지 스포이음이 대신 처리합니다.
								</span>
							</div>
							{/* </div> */}
							{/* <div className={styles.darkMainContentBottom}> */}

							{/* <div className={styles.borderRightGradient}> */}
							<div className={styles.mobileDarkMainContentItem}>
								<ArrowsPointingOutIcon className={styles.darkContentIcon} />
								<span className={styles.mobileWhiteBoldText}>
									검증된 파트너 POOL, 더 넓은 선택의 기회
								</span>
								<span className={styles.mobileWhiteText}>
									선수는 다양한 경력과 스타일의 캐디를 비교·선택할 수 있고, 캐디는
									여러 선수와의 장·단기 계약 기회를 확보할 수 있습니다.
								</span>
							</div>
							{/* <div> */}
							<div className={styles.mobileDarkMainContentItem}>
								<ChatBubbleOvalLeftEllipsisIcon
									className={styles.darkContentIcon}
								/>
								<span className={styles.mobileWhiteBoldText}>
									신뢰할 수 있는 안전 정산 시스템
								</span>
								<span className={styles.mobileWhiteText}>
									스포이음이 계약부터 정산까지, 투명하고 안전한 파트너십을
									보장합니다.
								</span>
							</div>
							{/* </div> */}
						</div>
					</div>
				)}

				<div className={styles.reviewWrapper}>
					<img src="/images/chatImage.png" className={styles.chatImage} />
					<div className={styles.reviewDetail}>
						<span>스포이음으로 매칭에 성공한</span>
						<span>프로와 캐디의 후기를 확인하세요!</span>
					</div>
					<SkewCarousel />
				</div>
				<div className={styles.offerWrapper}>
					<img src="/images/mapImage.png" className={styles.offerImage} />
					<div className={styles.offerMain}>
						<span>최적의 파트너와 함께, 필드 위</span>
						<span>새로운 역사를 만들 준비 되셨나요?</span>
					</div>
					<button className={styles.offerButton}>
						지금 바로 찾으러 가기
						<ChevronRightIcon className={styles.ChevronRightIcon} />
					</button>
				</div>
			</div>
			<MainFooter />
		</>
	)
}

export default Landing
